export { default } from '@/features/anonymousPurchasesStatistics/api';
